import { Thunk } from '../../../common/type';
import { getCustomers } from './customer-service';
import { CustomerActionKey, ICustomer } from './customer-type';

export type CustomerAction = {
  type: CustomerActionKey.SetCustomers;
  payload: { customers: ICustomer[] };
};

export const customerActionCreator = {
  setCustomers: (customers: ICustomer[]): CustomerAction => ({
    type: CustomerActionKey.SetCustomers,
    payload: { customers }
  }),
  // thunk
  initCustomerList: (): Thunk<Promise<CustomerAction>, CustomerAction> => dispatch =>
    getCustomers().then(customers => dispatch(customerActionCreator.setCustomers(customers)))
};



// WEBPACK FOOTER //
// ./src/modules/customers/parts/customer-action.ts